// @flow
import React from 'react'
import classNames from 'classnames'
import styles from './button.module.css'

type Props = {
  as: string | React$AbstractComponent<{}, any>,
  variant: 'primary' | 'inverted',
  size: 'small' | 'normal' | 'large',
  isDisabled: boolean,
  className?: string,
}

function Button({
  as: asProp,
  variant,
  size,
  isDisabled,
  className,
  ...props
}: Props) {
  const Component = isDisabled ? 'div' : asProp
  return (
    <Component
      {...props}
      className={classNames(
        styles.button,
        styles[variant],
        className,
        styles[size],
        {
          [styles.isDisabled]: isDisabled,
        },
      )}
    />
  )
}

Button.defaultProps = {
  as: 'button',
  variant: 'primary',
  size: 'normal',
  isDisabled: false,
}

export default Button
